import React, { Component } from 'react'; 
import {Row, Col, Button, Table, FormControl, InputGroup} from 'react-bootstrap';
import _ from 'lodash';
import DropDown from '../DynamicForm/DropDown'


 

export default class CSATAuditorScreen extends Component {
  constructor(props){
    super(props)
    this.state={      
      NA:false ,
      Fatal:false ,
      feedback:'',
      additionalField:[],
      searchedData:props.userData,
      toggle:true,
      toggleA:true,
      toggleF:false
    }
    this.copyData = [];
    this.isRating=false;
    this.isRatingYes=false;
    this.isNCReason1=false;
    this.isNCReason2=false;
    this.isNCReason3=false;
    this.isNCReason4=false;
    this.isNCReason5=false;
  }
  componentWillMount(){    
    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    var today = new Date(),
    date = today.getDate() +  '-' +  months[today.getMonth()] + '-' + today.getFullYear();
  //  let time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    this.setState({date:date})
  }
  componentDidMount(){
    const{auditorJson} = this.props    
    this.createTemplate(auditorJson.templateValue.Parameters)   
    this.additionalFieldBody(_.cloneDeep(auditorJson.templateValue.Additional))   
  }
  componentWillReceiveProps(nextProps){
    if(!_.isEmpty(nextProps.userData)){
      this.setState({searchedData:nextProps.userData})
    }
  }
  
  handleFeedback = (e) => {
    this.setState({feedback:e.target.value})
  }
  handleNA = (e, rowIndex) => {    
    let x= e.target.checked;
    this.setState((prevState) =>{
      if(typeof (prevState['NA'+rowIndex]) !== "undefined"){
        this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'NA':!prevState['NA'+rowIndex]})
        return {['NA'+rowIndex]: !prevState['NA'+rowIndex]};
      } else {
        this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'NA':x})
        return this.setState({['NA'+rowIndex]:x})
      }
    })
   //  this.setState({['NA'+rowIndex]:e.target.checked})
    // this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'NA':e.target.checked})
 }
  handleFatal = (e, rowIndex) => {
 this.setState({['Fatal'+rowIndex]:e.target.checked})
 this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'Fatal':e.target.checked})
  }
  handleFeedbackText = (e, rowIndex) => {
    this.setState({['textval'+rowIndex]:e.target.value})
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], 'feedback':e.target.value})
  }
  
  calculateReasons = (newObj, id, i, t) => { 
    let retobj = []
    retobj.push(<option value=''>Select NC Reason</option>)      
    _.map(newObj, (x)=> {
      retobj.push(<option selected={this.state['reason'+i+t] === x.label} value={x.label} >{x.label}</option>)
      return null
    })
    if(!_.isEmpty(newObj)){
    let path = this.state['reason'+i+t]? this.state['reason'+i+t] :''
    this.copyData[i]= ({...this.copyData[i], [id]:path})
    }
    return retobj;
  }
  handleChangeReason = (e, rowIndex, i) => {
    this.setState({['reason'+rowIndex+i]:e.target.value})
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], [e.target.id]:e.target.value})
  }
  handleChange = (e,rowIndex) => {
    this.setState({['rating'+rowIndex]:e.target.value})
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], "rating":e.target.value})
  }
  handleChangeRating= (e,rowIndex) => {
    this.setState({['textrating'+rowIndex]:e.target.value})
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], "textrating":e.target.value})
  }
  validateForm = () => {
    const {feedback, callType, issuesResolved, callRating, searchedData} = this.state
    if(feedback.length >0 && !_.isEmpty(callType) && !_.isEmpty(issuesResolved) && 
    !_.isEmpty(callRating)  && !_.isEmpty(searchedData)){
      return true
    }
  }
  keyPress = (e) =>{
    if(e.keyCode === 13){
      this.searchDataValues()     
   }
  }
  
  createTemplate = (json) => {
    let templateObj = [];
    _.map(json, (obj, paramindex) => {
      _.map(obj.attributes, (val, index) => {
        _.map(val.questions, (next, questindex) => {
          _.map(next.Scoring, (tt, scoreindex) => {
            let tempTemplateObj = {};
            let isParamDisable = ((paramindex < index) || (index < questindex)) ? true : false;
            let isAttribDisable = (index < questindex) ? true : false;
            tempTemplateObj.key = 'K' + templateObj.length
            tempTemplateObj.Parameters = {};
            tempTemplateObj.Parameters.id = "Parameters";
            tempTemplateObj.Parameters.value = obj;
            tempTemplateObj.Parameters.disabled = isParamDisable;
            tempTemplateObj.Attributes = {};
            tempTemplateObj.Attributes.id = "Attributes";
            tempTemplateObj.Attributes.value = val;
            tempTemplateObj.Attributes.disabled = isAttribDisable;
            tempTemplateObj.Questions = {};
            tempTemplateObj.Questions.id = "Questions";
            tempTemplateObj.Questions.value = next;
            tempTemplateObj.Scoring = {};
            tempTemplateObj.Scoring.id = "Scoring";
            tempTemplateObj.Scoring.value = tt;
            templateObj.push(tempTemplateObj);
            if(tt.textRating === true){
              this.isRatingYes=true
            } else {
              this.isRating = true
            }
            if(tt.NCReason1 === true){
              this.isNCReason1=true
            } 
            if(tt.NCReason2 === true){
              this.isNCReason2=true
            } 
            if(tt.NCReason3 === true){
              this.isNCReason3=true
            } 
            if(tt.NCReason4 === true){
              this.isNCReason4=true
            } 
            if(tt.NCReason5 === true){
              this.isNCReason5=true
            } 
          });
        });
      });
    });
    this.setState({ templateObj});
  }
  handleUserLayout = (e) =>{
    this.setState({term:e.target.value})     
  }
  searchDataValues = () =>{
    const{term} = this.state;
    if(!_.isEmpty(term)){
    let request={"employeeId":term, "regionId":this.props.region.inventoryRegionId,
    "centerId":this.props.center.inventoryCenterId,
    "clientId":this.props.client.inventoryClientId,
    "processId":20}
      this.props.function.TokenValidation()   
      this.props.function.actionSearch(request)    
   } 
  } 
  
  renderDocument(){
    const{date, term, searchedData} = this.state
    let data =[{'label':'Yes'}, {'label':'No'}] ;
    let Ndata =[{'label':'1'}, {'label':'2'}, {'label':'3'}, 
    {'label':'4'}, {'label':'5'}, {'label':'6'},{'label':'7'},{'label':'8'},{'label':'9'},
    {'label':'10'}] 
    let returnObj = (
      <div>       
        <Row className='information'>
         <Col><b>Employee ID <span className="RedColoring">*</span></b>
          <InputGroup>   
					<FormControl
						placeholder="Search"
						aria-label="Search"
						aria-describedby="basic-addon1"
						onChange={this.handleUserLayout}
            value={term}
            onKeyDown={this.keyPress}
						/>
          <InputGroup.Append>
          <Button variant="outline-secondary" onClick={this.searchDataValues}><i class="fas fa-search"></i></Button>
        </InputGroup.Append>       
				</InputGroup>
        </Col>          
          {(!_.isEmpty(searchedData)) ?
          <Col><b> Agent Name </b><br/><span className='colorBlue'>{searchedData.agentName}</span></Col>
          : <Col></Col>}
        <Col></Col>
        </Row>
        {(!_.isEmpty(searchedData)) ?  
        <Row className='information'>           
          <Col><b> Skill Set </b><br/><span className='colorBlue'>{searchedData.skillSetName}</span></Col>
          <Col><b> Tenure </b><br/><span className='colorBlue'>{searchedData.tenure}</span></Col>  
          <Col><b> TL Name </b><br/><span className='colorBlue'>{searchedData.tlName}</span></Col>                
        </Row>: null } 
        <Row className='information'>
        <Col><b> Auditor Name </b><br/><span className='colorBlue'>{this.props.loginUserName}</span></Col>
        <Col><b> Audited Date </b><br/><span className='colorBlue'>{date}</span></Col> 
        <Col><b> Process </b><br/><span className='colorBlue'>CSAT</span></Col>
        </Row>  
        {/* <Row className='information'>
        <Col><b> Region </b><br/><span className='colorBlue'>{this.props.region.inventoryRegionName}</span></Col>
        <Col><b> Center </b><br/><span className='colorBlue'>{this.props.center.inventoryCenterName}</span></Col> 
        <Col><b> Client </b><br/><span className='colorBlue'>{this.props.client.inventoryClientName}</span></Col>        
        </Row>          */}
        <Row>
          <div className='additionalInfo removeRadioButton'>
          <b>Issue Resolved<span className="RedColoring">*</span></b><br/>
        <DropDown multiple={false} options={data} object={data} onCallBack={(a)=>this.handleSelectIssues(a)}/>
          </div>
          <div className='additionalInfo removeRadioButton'>
          <b>Overall Call Rating<span className="RedColoring">*</span></b><br/>
          <DropDown multiple={false} options={Ndata} 
          object={Ndata} onCallBack={(a)=>this.handleSelectInformation(a)}/>
          </div>
          <div className='additionalInfo'>  
          <label><b>Call Type<span className="RedColoring">*</span></b>
            <FormControl
              placeholder=""
              aria-label="Search"
              aria-describedby="basic-addon1"
              onChange={this.handleCallType}
              value={this.state.callType}
              /></label>
          </div>        
        </Row>            
        <Row>
          {this.state.additionalField}
        </Row></div>)
     return returnObj

  }
  calculateOptions = (min, max, rowIndex) => {
    let UI =[];
    let selectedval = (typeof this.state['rating'+rowIndex] !== 'undefined') ? this.state['rating'+rowIndex] : max
    for(let j=min; j<=max; j++){
      let isEqual = _.isEqual(selectedval,j.toString())
      UI.push(<option selected={isEqual} value={j}>{j}</option>)
    }
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], "rating":selectedval})
    return UI;
  }
  RatingOptions = (rowIndex) => {
    let UI =[]
    UI.push(<option selected={this.state['textrating'+rowIndex] === 'yes'} value='yes'>Yes</option>,
    <option  selected={this.state['textrating'+rowIndex] === 'no'} value='no'>No</option>)
    this.copyData[rowIndex]= ({...this.copyData[rowIndex], "textrating":this.state['textrating'+rowIndex] ? this.state['textrating'+rowIndex] : 'yes'})
    return UI;
  }
  renderBody = () =>{ 
    const {templateObj} = this.state;  
    if(templateObj && templateObj.length > 0) {
      return _.map(templateObj, (row, rowIndex) => {
        let Scores = row.Scoring.value
        return (
          <tr  key={row.key}>
            <td className='Assesment'>{row.Parameters.value.label}</td>
            <td className='Assesment'>{row.Attributes.value.label === 'null' ? '' : row.Attributes.value.label}</td>
            <td className='Assesment'>{row.Questions.value.label === 'null' ? '' : row.Questions.value.label}</td>
            {/* <td><div className='assesment_Form'> */}
            <td>
              <label><center>{Scores.weight}</center></label> </td>
            <td> {(Scores.NA) ? <label><input type='radio' 
              checked={this.state['NA'+rowIndex]}
              onClick={(e)=>this.handleNA(e, rowIndex)}/></label> :'' }</td>
            {this.isRatingYes  ?   <td className={this.state['NA'+rowIndex] ? 'disabled'  :''}>            
              {(Scores.textRating) ? 
              <select id='Rating'  onClick={(e)=>this.handleChangeRating(e, rowIndex)}>
              {this.RatingOptions(rowIndex)}</select> :'' }
              </td> : null}
            {this.isRating  ?
              <td> {(Scores.textRating === false || typeof Scores.textRating === 'undefined') ?
              <label className={this.state['NA'+rowIndex] ? 'disabled'  :''}><select id='Rating' 
                 onClick={(e)=>this.handleChange(e, rowIndex)}> 
              {this.calculateOptions(Scores.min, Scores.max, rowIndex)}</select></label> : null}
              </td> : null}
              <td>
              {(Scores.Fatal) ? <label><input type='checkbox' checked={this.state['Fatal'+rowIndex]}
              value={this.state['Fatal'+rowIndex]}
                  onClick={(e)=>this.handleFatal(e, rowIndex)} /></label> :'' }
              </td>
              {this.isNCReason1 ? <td className='Assesment'>
              {(Scores.NCReason1 === true) ?
                <label className='NCReason'><select id='NCReason1' onClick={(e)=>this.handleChangeReason(e, rowIndex, 0)}>
                {this.calculateReasons(Scores['NC Reason 1object'], "NCReason1", rowIndex, 0)}</select></label> : null } </td> : null}
              {this.isNCReason2 ? <td className='Assesment'>
              {(Scores.NCReason2 === true) ? <label className='NCReason'><select id='NCReason2' onClick={(e)=>this.handleChangeReason(e, rowIndex, 1)}>
                {this.calculateReasons(Scores['NC Reason 2object'], 'NCReason2' , rowIndex, 1)}</select></label> : null }
              </td> : null}
              {this.isNCReason3 ?
              <td className='Assesment'>  
              {(Scores.NCReason3 === true) ?
               <label className='NCReason'>
                <select id='NCReason3' onClick={(e)=>this.handleChangeReason(e, rowIndex, 2)}>
                {this.calculateReasons(Scores['NC Reason 3object'], 'NCReason3' , rowIndex, 2)}</select></label> : null }
              </td>: null}
              {this.isNCReason4 ? <td className='Assesment'> 
              {(Scores.NCReason4 === true) ? 
                <label className='NCReason'>
                <select id='NCReason4' onClick={(e)=>this.handleChangeReason(e, rowIndex, 3)}>
                {this.calculateReasons(Scores['NC Reason 4object'], 'NCReason4' , rowIndex, 3)}</select></label>  : null }
              </td> : null}
              {this.isNCReason5 ? <td className='Assesment'> 
                {(Scores.NCReason5 === true) ?  
                 <label className='NCReason'>                
                <select id='NCReason5' onClick={(e)=>this.handleChangeReason(e, rowIndex, 4)}>
                {this.calculateReasons(Scores['NC Reason 5object'], 'NCReason5' , rowIndex, 4)}</select></label> : null }                  
              </td> : null}              
              <td>
              <label><textarea maxlength ="250" style={{'width':'100%'}} type='text' value={this.state['textval'+rowIndex]} 
              onChange={(e)=>this.handleFeedbackText(e, rowIndex)} /></label>
            </td>
           
          </tr>
        )
      });
    }
    return (
      <tr className=""><td colSpan="5">No Records found.</td></tr>
    );

  }

  additionalFieldBody = (Additional) => {
    let returnVal = (                  
             _.map(Additional, (data, index)=>{
              if(data.label === 'Drop Down'){
                return (<div className='additionalInfo'>
                  <DropDown options={data.additionalValues} multiple={true} object={data} onCallBack={(a)=>this.handleSelectDropDown(a, index)}/></div>);
              }
              else if(data.label === 'Text Box'){
                return ( <div className='additionalInfo'>
                <b>{data.labelObj}</b><br/><input type='text' maxlength ="255" value={this.state['addtext'+index]}
                onChange={(e)=>this.handleSelectTextBar(e, index, 'Text Box')}/></div>)
              }
              else if(data.label === 'Text Area'){
                return ( <div className='additionalInfo'>
                <b>{data.labelObj}</b><br/><textarea maxlength ="255" value={this.state['addtext'+index]}
                onChange={(e)=>this.handleSelectTextBar(e, index,'Text Area')}/></div>)
              }             
            })                   
         )
    this.setState({additionalField:returnVal})
   
  }
  handleSelectDropDown = (a, index) => {
    const{auditorJson} = this.props
    auditorJson.templateValue.Additional[index].selected = a;
  }
  handleSelectTextBar = (e, index, label) =>{
    const{auditorJson} = this.props
    this.setState({['addtext'+index]:e.target.value})
    if(label === 'Text Area'){
      auditorJson.templateValue.Additional[index].textAreaValues = e.target.value;
     } else {
       auditorJson.templateValue.Additional[index].textBoxValues = e.target.value;      
    }
  }
  handleSelectIssues = (a) => {
    this.setState({issuesResolved:a})
  }
  handleSelectInformation = (a) => {
    this.setState({callRating:a})
  }
  handleCallType = (e) => {
    this.setState({callType:e.target.value})
  }
  additionalClone = () =>{
    let x = _.cloneDeep(this.props.auditorJson)
    let additional = x.templateValue.Additional
    if(!_.isEmpty(additional)){
    _.map(additional, (obj) =>{
      if(obj.label === 'Text Area' && _.isEmpty(obj.textAreaValues)){
        obj.textAreaValues=''
      } else if(obj.label === 'Text Box' && _.isEmpty(obj.textBoxValues)){
        obj.textBoxValues=''
      }
    })
    }
    return x;
  }
  
  onSubmit = () => {
    let obj = {'Scores':this.copyData, 'FinalFeedback':this.state.feedback, "EvaluationDate": this.state.date,
    "QAName": this.props.loginUserName}
    let info = {'CallType':this.state.callType, 'Issues': this.state.issuesResolved ,
    'Region': this.props.region, 'Center': this.props.center, 'Client': this.props.client, 'Process': this.props.process, 
    'Call Rating':this.state.callRating, 'Details': this.state.searchedData, 
    'Date':this.state.date,
    'EmployeeID':this.state.term}
    let x = this.additionalClone()
    x.templateValue = {...x.templateValue, 'Readonly':obj}
     let object = {
       ...x,
       'Information':info
      }
     this.props.function.TokenValidation()  
     this.props.function.actionSubmit(object)
     this.setState({searchedData:[]})
     this.props.closeModal()
  } 
  handleInformation = () =>{
    this.setState((prevState) =>{
      return {toggle: !prevState.toggle};
    })
  }
  handleAssesment = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  handleFeedbackToggle = () =>{
    this.setState((prevState) =>{
      return {toggleF: !prevState.toggleF};
    })
  } 
  
  
  render(){
    const{toggle, toggleA, toggleF} = this.state;
    return(
      <div>  
      <h6 className={toggle ? 'evalFormMargin': 'evalForm'} onClick={this.handleInformation} >
      {toggle ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} INFORMATION</h6>  
      <div className={toggle ? 'assesmentShow': 'assesmentHide'}>       
        {this.renderDocument()}        
       </div>
       <h6 className={toggleA ? 'evalFormMargin': 'evalForm'} onClick={this.handleAssesment}>
        {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} ASSESMENT</h6>        
        <div className={toggleA ? 'assesmentShow': 'assesmentHide'}> 
        <Table responsive>        
          <thead>
            <tr>
            <th>Parameters</th>
              <th>Attributes</th>
              <th>Questions</th>
              <th>Wtg.</th>
              <th>NA</th>
              {this.isRatingYes ? <th>Rating<br/>(Y/N)</th> : null}      
              {this.isRating  ?<th>Rating</th> : null}
              <th>Fatal</th>
              {this.isNCReason1 ? <th style={{width:'250px'}}>NCReason 1</th> : null}
              {this.isNCReason2 ?<th style={{width:'250px'}}>NCReason 2</th> : null}
              {this.isNCReason3? <th style={{width:'200px'}}>NCReason 3</th> : null}
              {this.isNCReason4 ?<th style={{width:'200px'}}>NCReason 4</th> : null}
              {this.isNCReason5 ? <th style={{width:'200px'}}>NCReason 5</th> : null}
              <th style={{width:'160px'}}>Feedback</th>   
            </tr>
          </thead>
          <tbody>
            {
              this.renderBody()
            }
        </tbody>
        </Table>
        </div>
        <h6 className={toggleF ? 'evalFormMargin': 'evalForm'} onClick ={this.handleFeedbackToggle}>
        {toggleF ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} FEEDBACK</h6> 
        <div className={toggleF ? 'assesmentShow': 'assesmentHide'}>
        <Row>            
            <Col style={{'marginLeft':'10px'}}>
              <b> Evaluation Date </b>: {this.state.date}<br/>
              <b> QA Name </b> : {this.props.loginUserName} 
            </Col>
            <Col>
            <b>Feedback</b><span className="RedColoring">*</span>
            <textarea style={{'width':'100%'}}
            value={this.state.feedback} 
            maxlength ="1200"
            onChange={this.handleFeedback}/>
            </Col>
            
             <Col md={1}><Button className='buttonwidth'  disabled={!this.validateForm()} onClick={this.onSubmit}>Submit</Button></Col>
             <Col md={1}></Col>
            </Row>
              </div> 
      </div>
    
    )
  }
}